module.exports = __webpack_public_path__ + "img/home.f28574d.jpg?v=1791296779994";